import type { GModalConfirmInitialValues } from '~/presentation/common';

import { useGModalContext, ModalType } from '~/presentation/ui';
import { useState } from 'react';

interface UseGModalConfirmProps {
  onSuccess?: (data: GModalConfirmInitialValues) => Promise<void>;
}

export const useGModalConfirm = (params?: UseGModalConfirmProps) => {
  const { onOpenModal, initialValues, onCloseModal } = useGModalContext<ModalType.CONFIRM>();
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenModalConfirm = (data: GModalConfirmInitialValues) => {
    onOpenModal(ModalType.CONFIRM, data);
  };

  const handleConfirm = async () => {
    if (!initialValues) {
      throw new Error('initialValues is required');
    }

    setIsLoading(true);
    try {
      const dataUpdated = await initialValues?.primaryAction?.onAction?.();
      await params?.onSuccess?.(initialValues);
      return dataUpdated;
    } finally {
      setIsLoading(false);
      onCloseModal();
    }
  };

  const handleCancel = async () => {
    try {
      await initialValues?.secondaryActions?.onAction?.();
    } catch (error) {
    } finally {
      onCloseModal();
    }
  };

  return {
    isLoading,
    initialValues,
    onCloseModal,
    handleCancel,
    handleConfirm,
    handleOpenModalConfirm,
  };
};
